import React from "react"
import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles"
import { ThemeProvider } from "@material-ui/styles"
import { red } from "@material-ui/core/colors"

const Themeify = (props) => {
    const theme = createMuiTheme({
        palette: {
            type: "light",
            primary: {
                main: "#42acb3",
                contrastText: '#fff',
            },
            secondary: {
                main: red[500],
                contrastText: '#fff'
            },
            text: {
                primary: 'rgba(0, 0, 0, 0.87)',
                secondary: 'rgba(0, 0, 0, 0.87)',
            }
        },
        overrides: {
            MuiAppBar: {
                colorDefault: {
                    backgroundColor: '#fff'
                }
            }
        }
    })
    const responsiveTheme = responsiveFontSizes(theme)
    return (
        <ThemeProvider theme={responsiveTheme}>
            {props.children}
        </ThemeProvider>
    )
}
export default Themeify